export enum NotificationType {
  ERROR,
  SUCCESS,
}
